import { computed, inject, ref } from 'vue';
import { defineStore } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useStoreRestaurant } from './restaurant';
import { useStoreOrder } from './order';

export const useStoreSeo = defineStore('seo', () => {

  const rStore = useStoreRestaurant();
  const oStore = useStoreOrder();
  const { setLocaleMessage, t, locale } = useI18n();

  function setSeoMeta(title, description) {
    let meta = [];

    meta.push({
      name: 'title',
      content: title
    });

    meta.push({
      name: 'description',
      content: description
    });

    meta.push({
      name: 'og:title',
      content: title
    });

    meta.push({
      name: 'og:description',
      content: description
    });

    meta.push({
      name: 'og:image',
      content: rStore.restaurant.logo
    });

    meta.push({
      name: 'twitter:title',
      content: title
    });

    meta.push({
      name: 'twitter:description',
      content: description
    });

    meta.push({
      name: 'twitter:image',
      content: rStore.restaurant.logo
    });

    return {
      title,
      description,
      meta
    };
  }

  let seo = computed(() => {
    const restaurant = rStore.restaurant;
    const pos = rStore.posDetails;
    const category = oStore.category;
    const deliveryMethod = oStore.deliveryMethod;

    let meta = ref({
      title: "",
      description: ""
    });

    if (!restaurant) {
      if (rStore.isLoading) {
        meta.value.title = t('loader.default');
        meta.value.description = t('loader.default');
        return meta;
      } else {
        meta.value.title = t('restaurant_not_found');
        meta.value.description = t('restaurant_not_found');
        return meta;
      }
    }

    // set as favicon the restaurant logo
    let favicon = document.querySelector('link[rel="icon"]');
    if (favicon && restaurant.logo) {
      favicon.href = restaurant.logo;
    }

    let title = "";
    let description = "";

    title = restaurant.name + ' | ';

    if (!restaurant.has_subrestaurant) {
      title += restaurant.city;
    }

    description = `Il menu di ${restaurant.name} ${restaurant.city}`;

    if (!restaurant.has_subrestaurants)	// multilocale: non visualizzo la città, dato che potrebbe essere in più città
    {
      if (restaurant.city) {
        title += ' - ' + restaurant.city;
      }
    }

    if (deliveryMethod && deliveryMethod.code == '0t') {
      title += ' - ' + t('customer_table_menu');
    } else {
      title += ' - ' + t(restaurant.delivery ? 'order_online_delivery' : 'order_online');
    }


    if (category) {
      title += ' - ' + t('menu_x', category.name);
      description += ' - ' + category.name;
    }

    if (deliveryMethod && deliveryMethod.code == '0t') {
      description += ": " + t('customer_table_menu');
    }
    else {
      if (restaurant.delivery)
        description += ": ordina online con ritiro o consegna a domicilio.";
      else
        description += ": ordina online.";
    }

    return setSeoMeta(title, description);
  });

  return {
    seo
  }
})
